import { VueRenderer } from '@tiptap/vue-3';
import tippy, { Instance } from 'tippy.js';
import { SlashCommand, commands, groupCommandsByType } from './commands';
import SlashCommandSearchList from '@/components/widgets/SlashCommandSearchList.vue';
import Fuse from 'fuse.js';
import { ResourceType } from '@/types/resources';
import { store } from '@/store';
import { getRectOrDestroy } from '../util';
import setMaxHeight from '@/utilities/setMaxHeight';

export default {
  fuse: new Fuse([] as SlashCommand[], { keys: ['searchName'] }),
  items: function ({ query, resourceType }: { query: string; resourceType: ResourceType }) {
    return {
      /**
       * Apply the same function as in the component, to ensure the same order of results.
       */
      result: groupCommandsByType(
        query ? this.fuse.search(query).map((r) => r.item) : commands,
        resourceType,
        store
      ).flatMap((g) => g.results),
      query,
    };
  },
  render() {
    let component: VueRenderer;
    let popup: Instance[];

    return {
      onStart: (props: any) => {
        component = new VueRenderer(SlashCommandSearchList as any, {
          props,
          editor: props.editor,
        });

        if (!props.clientRect) {
          return;
        }

        popup = tippy('body', {
          getReferenceClientRect: getRectOrDestroy(props.clientRect, () => popup),
          appendTo: () => document.body,
          content: component.el || undefined,
          showOnCreate: true,
          interactive: true,
          trigger: 'manual',
          placement: 'bottom-start',
          role: 'poper',
          onShow: setMaxHeight,
          maxWidth: '100%',
        });

        this.fuse = new Fuse(
          commands.filter((c) => c.resource.includes(props.resourceType)),
          {
            keys: ['searchName', 'category', 'keywords'],
          }
        );
      },

      onUpdate(props: any) {
        component.updateProps(props);

        if (!props.clientRect) {
          return;
        }

        popup[0].setProps({
          getReferenceClientRect: getRectOrDestroy(props.clientRect, () => popup),
        });
      },

      onKeyDown(props: any) {
        if (props.event.key === 'Escape') {
          popup[0].hide();

          return true;
        }

        return component.ref?.onKeyDown?.(props);
      },

      onExit() {
        popup?.[0]?.destroy?.();
        component?.destroy?.();
      },
    };
  },
};
